import $ from 'jquery'
import Player from '@vimeo/player'

/* VIDEO AUTOPLAY
  ----------------------------- */
export const videoAutoplay = () => {
  if ($('.homepage__video-wrapper').length) {
    let players = []

    $('.homepage__video-wrapper').each(function() {
      let btn = $(this).find('.homepage__video-btn')
      const videoId = this.id
      var player = new Player(videoId, {
        loop: true,
        autoplay: true,
        autopause: true,
        background: true
      })

      players.push(player)
      player.setVolume(0)

      btn.on('click', function() {
        $.each(players, function(i, player) {
          player.setVolume(0)
        })

        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          player.setVolume(0)
          if ($(window).width() < 832) player.pause()
        } else {
          $('.homepage__video-btn').removeClass('active')
          $(this).addClass('active')
          player.setVolume(1)
          if ($(window).width() < 832) player.play()
        }
      })
    })
  }
}

/* VIDEO FOLLOW BTN
  ----------------------------- */
export const videoFollowBtn = () => {
  if ($(window).width() > 832) {
    $('#video-desktop').on('mouseenter', function(e) {
      const $btn = $(this).find('.homepage__video-btn')
      var itemOffset = $(this).offset()
      var relX = e.pageX - itemOffset.left - 78
      var relY = e.pageY - itemOffset.top - 78

      $btn.css("top",(relY) + "px").css("left",(relX) + "px")
    })
    .on('mousemove', function (e) {
      const $btn = $(this).find('.homepage__video-btn')
      var itemOffset = $(this).offset()
      var relX = e.pageX - itemOffset.left - 78
      var relY = e.pageY - itemOffset.top - 78
      
      $btn.css("top",(relY) + "px").css("left",(relX) + "px")
    })
    .on('mouseleave', function (e) {
      console.log('leave')
      const $btn = $(this).find('.homepage__video-btn')
      $btn.css("top","auto").css("left","auto")
    })
  }
}

/* HOME OPEN ACCORDION
  ----------------------------- */
const bindHomeAccordion = (sectionSelector) => {
  const $section = $(sectionSelector)
  if (!$section.length) return

  $section.on('click', '.section__abstract', function() {
    const $line = $(this).parent()
    const wasOpen = $line.hasClass('open')

    $section.find('.section__line').removeClass('open')
    $section.find('.section__body').slideUp()
    $section.removeClass('open')

    if (!wasOpen) {
      $line.addClass('open')
      $(this).next().slideDown()
      $section.addClass('open')
    }
  })
}

export const homeOpenAccordion = () => {
  bindHomeAccordion('.homepage__section-about')
  bindHomeAccordion('.homepage__section-intro')
  bindHomeAccordion('.user-profile')
}

/* JOURNAL + RASSEGNE LINK TARGET
  ----------------------------- */
export const forceLinkTarget = () => {
  $('.journal__attachment a, .rassegna__link a').each(function() {
    $(this).attr("target", "_blank")
  })
}

/* VIEW HEADER SHRINK ON SCROLL
  ----------------------------- */
export const viewHeaderShrink = () => {
  const $header = $('.view-header')
  if (!$header.length) return
  const threshold = 60
  const hysteresis = 20
  let isSticky = false
  let ticking = false

  const apply = () => {
    const y = window.scrollY
    if (!isSticky && y > threshold) {
      $header.addClass('sticky')
      isSticky = true
    } else if (isSticky && y < threshold - hysteresis) {
      $header.removeClass('sticky')
      isSticky = false
    }
    ticking = false
  }

  $(window).on('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(apply)
      ticking = true
    }
  })
  apply()
}


window.onload = () => {
  videoAutoplay()
  // videoFollowBtn()
  homeOpenAccordion()
  forceLinkTarget()
  viewHeaderShrink()
}